import React, { memo } from "react";
import { RCCBadge, RCCButton, RCCGrid, RCCIcon, RCCProgress, RCCTooltip } from "react-common-components";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { ActionEfficiency, ActionSituationFilter } from "src/pages/Actions/Panel/interface";
import formatDate from "src/utils/formatDate";
import {formatMinutesInHours} from "src/utils/formartHourMinutes";
import { IListActionsComponent } from "./interface";
import OverflowSpan, { DivFlex, DivFlexColumn, DivIcons, RedSpan, StyledIcon, StyledSpan } from "./styles";
import BadgeTraceabilityCard from "../BadgeTraceability/badgeTraceabilityCard";

const ListActions: React.FC<IListActionsComponent> = ({
	data,
	options,
	openModalComments,
	openModalSubactions,
	filter,
	openModalAttachments,
	openModalPostPonementConfirm,
	openModalCancelConfirm,
	openModalEfficiency,
	openModalChangeProgress,
	openModalRelateSprint,
	openModalShowPostponements,
	layout
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colAction = (row: any) => (
		<OverflowSpan isProject={layout === "project" || layout === "projectAgile"} title={`${row.inb001Codigo ? `${row.inb001Codigo} - ` : ""} ${row.inb001Titulo}`}>{row.inb001Codigo ? `${row.inb001Codigo} - ` : ""}{row.inb001Titulo}</OverflowSpan>
	);

	const colUser = (row: any) => (
		<UserColumn 
			name={row.inb001Efa005Nome}
			image={row.inb001Efa005Imagem}
		/>
	);

	const colUser2 = (row: any) => (
		<UserColumn 
			name={row.inb001Efa005Nome2}
			image={row.inb001Efa005Imagem2}
		/>
	);

	const colBadgesAndOptions = (row: any) => {
		let {daysCount} = row;
		let color: "grey" | "green" | "blue" | "red" | "yellow" | "purple" = "grey";
		switch(row.situation){
		case ActionSituationFilter.FINISHED:
			daysCount = 0;
			color = "green";
			break;
		case ActionSituationFilter.DELAYED:
			color = "red";
			break;
		case ActionSituationFilter.NOT_STARTED:
			daysCount = 0;
			color = "purple";
			break;
		case ActionSituationFilter.IN_PROGRESS:
			daysCount = 0;
			color = "blue";
			break;
		case ActionSituationFilter.NEXT_TO_EXPIRE:
			color = "yellow";
			break;
		default: 
			daysCount = 0;
			break;
		}
		return(
			<>
				<RCCGrid
					container 
					item
					alignItems="center"
					justifyContent="space-between" 
				>
					<DivFlex wrap>
						<DivFlexColumn>
							{ row.situation !== ActionSituationFilter.FINISHED && row.situation !== ActionSituationFilter.CANCELED   && 
					 row.situation !== ActionSituationFilter.DRAFT  ? (
						 <RCCButton color={color} onClick={() => openModalChangeProgress(row)} styleInline="padding: 2px 8px; border-radius: 10px; font-size: 0.78rem;">{translate(row.situation)}{daysCount === 0 ? "" : `: ${Math.abs(daysCount)} ${translate("dia(s)")}`}</RCCButton>
					 ): (<RCCBadge color={color} styleInline="padding: 2px 8px; font-size: 0.78rem;">{translate(row.situation)}{daysCount === 0 ? "" : `: ${Math.abs(daysCount)} ${translate("dia(s)")}`}</RCCBadge>)}
							<BadgeTraceabilityCard 
								hideBadge={layout === "project" || layout === "projectAgile"}
								id={row.inb001Id}
								codTraceability={row.traceability}
							/>
							{row.isSubaction && (
								<RCCBadge color="grey" styleInline="padding: 2px 8px; font-size: 0.78rem;" >{translate("Subação")}</RCCBadge>
							)}
							{row.efficiency !== ActionEfficiency.NOT_NEEDED && (
								<>
									{row.efficiency === ActionEfficiency.NEEDED ? (
										<RCCBadge color="yellow" styleInline="padding: 2px 8px; font-size: 0.78rem; cursor: pointer;" onClick={() => openModalEfficiency(row)} >{translate("Requer eficácia")}</RCCBadge>
									): (
										<RCCBadge color="red" styleInline="padding: 2px 8px; font-size: 0.78rem; cursor: pointer;" onClick={() => openModalEfficiency(row)} >{translate("Eficácia atrasada")}</RCCBadge>
									)}
								</>
							)}
							{row.situation !== ActionSituationFilter.FINISHED && row.situation !== ActionSituationFilter.CANCELED && 
					 	 row.situation !== ActionSituationFilter.DRAFT && (
								<>
									{row.hasPostponement && (
										<RCCTooltip
											color="yellow"
											text={translate("Alerta postergação")}
										>
											<DivIcons onClick={() => openModalPostPonementConfirm(row)}>
												<RCCIcon name="exclamationTriangle" color="var(--yellow)" size={14}/>
											</DivIcons>
										</RCCTooltip>
									)}
									{row.hasCancel && (
										<DivIcons onClick={() => openModalCancelConfirm(row)}>
											<RCCIcon name="exclamationTriangle" color="var(--red)" size={14}/>
										</DivIcons>
									)}
								</>
							)}
						</DivFlexColumn>
						<DivFlex>
							{row.situation === ActionSituationFilter.FINISHED && row.efficiency === ActionEfficiency.NOT_NEEDED && row.inb001Exigeeficacia === "S" && (
								<RCCTooltip
									text={translate("Eficácia")}
								>
									<DivIcons onClick={() => openModalEfficiency(row)}>
										<RCCIcon name="listCheck" color="var(--default-color-font)" size={20}/>
									</DivIcons>
								</RCCTooltip>
							)}
							<RCCTooltip
								text={translate("Comentários")}
							>
								<DivIcons onClick={() => openModalComments(row)}>
									{row.commentsNumber > 0 ? (
										<>
											<RCCIcon name="commentFilled" color="var(--default-color-font)" size={12}/>
											{row.commentsNumber}
										</>
									) : (
										<RCCIcon name="comment" color="var(--default-color-font)" size={12}/>
									)}
								</DivIcons>
							</RCCTooltip>
							<RCCTooltip
								text={translate("Anexos")}
							>
								<DivIcons onClick={() => openModalAttachments(row, true)}>
									<RCCIcon name="attachment" color="var(--default-color-font)" size={12}/>
									{row.attachmentsNumber > 0 && row.attachmentsNumber}
								</DivIcons>
							</RCCTooltip>
							 {(layout === "project" || layout === "projectAgile")  && (
								<DivIcons onClick={() => {
									if(openModalRelateSprint) 
										openModalRelateSprint(row, layout === "projectAgile" ? translate("Alterar Sprint") : translate("Alterar Fase"));
								}}>
									<RCCTooltip
										color="purple"
										text={layout === "projectAgile" ? translate("Alterar Sprint") : translate("Alterar Fase")}
									>
										<RCCIcon name="exchange" color="var(--default-color-font)" size={12}/>
									</RCCTooltip>
								</DivIcons>
							 )}
							<RCCTooltip
								text={translate("Subações")}
							>
								{row.subactionsNumber > 0 && (
									<div
										style={{ display: "flex", alignItems: "center" }}
									>
										<StyledIcon 
											name="tree"
											size={18}
											onClick={() => openModalSubactions(row)}
										/>
										<StyledSpan>
											{row.subactionsNumber}
										</StyledSpan>
									</div>
								)}
							</RCCTooltip>
						</DivFlex>
					</DivFlex>
					{options(row)}
				</RCCGrid>
				<div style={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", background: `var(--${color})`}}/>
			</>
		);};

	const colPeriod = (row: any) => (
		<RCCGrid 
			item
			container
			direction="column"
			alignItems="center"
			justifyContent="flex-start"
		>
			{row.inb003Dtfim && (
				<RCCGrid style={{ cursor: "pointer" }} container item onClick={() => openModalShowPostponements(row)}>
					<RCCIcon 
						name="calendar"
						size={16}
						color="var(--red)"
						style={{marginRight: "4px"}}
					/>
					<RedSpan>{formatDate(row.inb003Dtfim, currentLanguage)}</RedSpan>
		  		</RCCGrid>
			)}
			<RCCGrid container item alignItems="center">
				<RCCIcon 
					name="calendar"
					size={16}
					color="var(--default-color-font)"
					style={{marginRight: "4px"}}
				/>
				{formatDate(row.inb001Dtinicio, currentLanguage)} - {formatDate(row.inb001Dtfim, currentLanguage)}
		  </RCCGrid>
	
		</RCCGrid>
	);

	const colPercent = (row: any) => {
		let percentageColor = "";
		switch(row.percentageColorConcluded){
		case "red":
			percentageColor = "var(--red)";
			break;
		case "yellow":
			percentageColor = "var(--yellow)";
			break;
		default: 
			percentageColor = "var(--purple)";
			break;
		}

		return (
			<>
				{row.isTask ? (
					<RCCGrid
						container
						item
						alignItems="center"
						direction="column"
						style={{position: "relative"}}
					>
						<RCCGrid container item alignItems="center">
							<RCCIcon 
								name="clock"
								color="var(--default-color-font)"
								size={16}
							/>
							<Title color="purple" marginBottom={0} marginTop={0} styleInline="font-size: 0.85rem;">
								{formatMinutesInHours(row.taskDurationRealized)}
							</Title>
						/
							<Title color="defaultColor" marginBottom={0} marginTop={0} styleInline="font-size: 0.85rem;">
								{formatMinutesInHours(row.taskDuration)}
							</Title>
							{row.situation !== ActionSituationFilter.FINISHED && row.situation !== ActionSituationFilter.CANCELED &&  row.situation !== ActionSituationFilter.DRAFT && (
								<>
									{row.inb004Id && row.inb004Id > 0 && !row.inb004DataFinal ? (	
										<RCCTooltip
											text={translate("Pausar tarefa")}	
											color="grey"			
										>
											<RCCButton 
												onClick={() => openModalChangeProgress(row)} 
												color="transparent"
												icon={{
													name: "pause",
													size: 10,
													color: "var(--default-color-font)"
												}}
											/>	
										</RCCTooltip>	
									) : (
										<RCCTooltip
											text={translate("Iniciar tarefa")}	
											color="grey"			
										>
											<RCCButton 
												onClick={() => openModalChangeProgress(row)} 
												color="transparent"
												icon={{
													name: "play",
													size: 14,
													color: "var(--default-color-font)"
												}}
												styleInline="margin: 0; padding: 0;"
											/>	
										</RCCTooltip>	
									)}
								</>
							)}
						</RCCGrid>
						<RCCProgress 
							color={percentageColor}
							value={row.inb001PercConclusao} 
							layout="line"
							onClick={() => openModalAttachments(row, false)}
							styleInline="cursor: pointer;"
						/>
					</RCCGrid>
				):(
					<RCCGrid
						container
						item
						alignItems="center"
					>
						<RCCProgress 
							color={percentageColor}
							width={undefined} 
							value={row.inb001PercConclusao} 
							layout="line"
							onClick={() => openModalAttachments(row, false)}
							styleInline="cursor: pointer;"
						/>
					</RCCGrid>
				)}
			</>
		);
	};

	const colPercentPrevisto = (row: any) => (
		<RCCGrid
			container
			item
			alignItems="center"
		>
			<RCCProgress 
				value={row.percentagePredicted} 
				layout="line"
			/>
		</RCCGrid>
	);
    
	return(
		<List 
			data={data}
			filter={filter}
			columns={layout === "project" || layout === "projectAgile" || layout === "withProgressBarPredicted" ? 
				[{
					idColumn: "title",
					nameColumn: translate("Ação"),
					xs: 12,
					sm: 4,
					justify: "left",
					cellRenderer: colAction
				},{
					idColumn: "responsible",
					nameColumn: translate("Responsável"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colUser
				},{
					idColumn: "period",
					nameColumn: translate("Período"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colPeriod
				},
				{
					idColumn: "percent",
					nameColumn: translate("Realizado"),
					justify: "left",
					xs: 12,
					sm: 1,
					cellRenderer: colPercent
				},{
					idColumn: "percent2",
					nameColumn: translate("Previsto"),
					justify: "left",
					xs: 12,
					sm: 1,
					hidden: ["sm"],
					cellRenderer: colPercentPrevisto
				},{
					idColumn: "details",
					nameColumn: " ",
					xs: 12,
					sm: 1,
					md: 2,
					justify: "left",
					cellRenderer: colBadgesAndOptions
				}]
				:
				[{
					idColumn: "title",
					nameColumn: translate("Ação"),
					xs: 12,
					sm: 3,
					justify: "left",
					cellRenderer: colAction
				},{
					idColumn: "responsible",
					nameColumn: translate("Responsável"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colUser
				},{
					idColumn: "authority",
					nameColumn: translate("Autoridade"),
					xs: 12,
					sm: 2,
					hidden: ["sm"],
					justify: "left",
					cellRenderer: colUser2
				},{
					idColumn: "period",
					nameColumn: translate("Período"),
					xs: 12,
					sm: 2,
					justify: "left",
					cellRenderer: colPeriod
				},
				{
					idColumn: "percent",
					nameColumn: translate("Percentual"),
					justify: "left",
					xs: 12,
					sm: 1,
					cellRenderer: colPercent
				},{
					idColumn: "details",
					nameColumn: " ",
					xs: 12,
					sm: 4,
					md: 2,
					justify: "left",
					cellRenderer: colBadgesAndOptions
				}]}
			layout={layout === "project" || layout === "projectAgile" || layout === "table" ? "table" : undefined}
			showHeader={layout !== "project" && layout !== "projectAgile"}
			styleInline="li.list-component-child { border-top-left-radius: 0; border-bottom-left-radius: 0; }"
		/>
	);};

export default memo(ListActions);
